import { render, staticRenderFns } from "./CustomNotification.vue?vue&type=template&id=08ca8ea8&"
import script from "./CustomNotification.vue?vue&type=script&lang=js&"
export * from "./CustomNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports